import {CLSelectorOption} from 'common/src/components/Selectors/CLSelector/CLSelector.types';

enum DateTimeType {
  DateTime = 'datetime',
  Date = 'date',
  Time = 'time',
}

enum TimezoneType {
  Local = 'local',
  Client = 'client',
  UTC = 'utc',
}

interface TimezoneObject {
  id: string;
  baseUtcOffset: number;
  currentOffset: number;
  abbr: string;
}

enum TimezoneSource {
  Manual = 0,
  User = 1,
  Advertiser = 2,
}

interface DateTimeInfo {
  timezoneMapper: {[id: string]: TimezoneObject};
  timezonesForSelector: Array<CLSelectorOption>;
  currentClientTimezone: TimezoneObject;
  clientTimeFormat: string;
  clientDateFormat: string;
}

type TimezoneWithOption = TimezoneObject & {value: string; label: string};

export {
  DateTimeType,
  TimezoneType,
  TimezoneSource,
  TimezoneObject,
  DateTimeInfo,
  TimezoneWithOption,
};
